"use client";

/**
 * App binding for the brandless @repo/nps survey: injects the brand-resolved
 * config (see ../brand), so call sites keep the original
 * <NpsDrawer isOpen onClose dismissOnTabSwitch> surface.
 */
import { NpsDrawer as PackageNpsDrawer } from "@repo/nps/components";
import type { NpsCloseReason } from "@repo/nps";
import { npsBrandConfig } from "../brand";

interface NpsDrawerProps {
  isOpen: boolean;
  onClose: (reason?: NpsCloseReason) => void;
  dismissOnTabSwitch?: boolean;
}

export function NpsDrawer(props: NpsDrawerProps) {
  return <PackageNpsDrawer {...props} config={npsBrandConfig} />;
}
